import React, { Component } from 'react'
import ArrowDown from 'react-icons/lib/md/arrow-drop-down';
import withMedia from '../../containers/withmedia';
import Scroller from '../pagescreen/scroller';
import style from './style.css';

class DropSlider extends Component {
    constructor(props){
        super(props)
        this.state = { opened: props.showAll ? true : false, current_photo: 0 }
        this._toggle_slider = this._toggle_slider.bind(this)
        this._current_slide = this._current_slide.bind(this)
    }
    _toggle_slider(){
        this.setState({ ...this.state, opened: !this.state.opened })
    }
    _current_slide(idx, idxlatest){
        if(idx < 0 || idx > (this.props.count - 1 )) { return }
     this.setState({ current_photo: idx }); 	
    }
    render() {
        const count = this.props.count
        //const items = Array(count).fill(1)
        const windowWidth = "innerWidth" in window ? window.innerWidth : document.documentElement.offsetWidth;
        return (
            <div className={ `${ style.container } ${ this.state.opened ? style.opened : style.closed }` }>
                <div className={ style.headBanner } onClick={ this._toggle_slider } style={ this.props.styles || {} }>
                    <h4>
                        { this.props.title }
                        <div className={ style.showAllLink }>{ this.state.opened ? 'Hide' : 'Show'} All</div>
                    </h4>
                    <ArrowDown className={ style.arrowDown }/>
                </div>
                <div className={ `${ style.backdrop }`  }>
                    <div className={ style.frame }>
                        {this.props.children && 
                        <Scroller items={ this.props.children} width={ this.props.children.length * windowWidth } />
                        }
                    </div>
                </div>
            </div>
        )
    }
}
                        // <div className={ style.dotnav}>
                        //         { items.map( ( e , i ) => 
                        //             <div key={`navdot_${i}`} className={ i===this.state.current_photo ? style.activeDot : style.inactiveDot }></div>
                        //         )}
                        // </div>
                        // <SwipeableViews 
                        //     className={ style.swipeable }  
                        //     onChangeIndex={ (idx, latest) => this._current_slide(idx, latest) }
                        //     hysteresis={ 0.1 }
                        //     threshold={ 1 }
                        //     animateHeight={true} 
                        //     children={ this.props.children} />


export default withMedia(DropSlider)



// WEBPACK FOOTER //
// ./src/components/dropslider/index.js